export const ShoppingBag = (props) => {
  const width = (props.size * 25) / 24 || 25;
  const height = props.size || 24;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.4993 5C10.4993 3.89543 11.3947 3 12.4993 3C13.6039 3 14.4993 3.89543 14.4993 5M21.1448 18.6959L19.7602 9.69589C19.6101 8.72022 18.7706 8 17.7834 8H7.21512C6.22798 8 5.38848 8.72022 5.23838 9.69589L3.85376 18.6959C3.66738 19.9074 4.60474 21 5.83051 21H19.1681C20.3938 21 21.3312 19.9074 21.1448 18.6959Z"
        stroke={props.color || 'currentColor'}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
